import { lazy, Suspense } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { AuthGuard } from "@lib/components/AuthGuard";
import { ForbiddenPage } from "@lib/pages/forbidden/ForbiddenPage";
import { NotFoundPage } from "@lib/pages/notfound/NotFoundPage";
import Configuration from "@common/Configuration";
import { PublicLayout } from "@common/layout/PublicLayout";
import { ShellFallback } from "@common/layout/ShellFallback";
import { HomeDispatcher } from "@common/pages/HomeDispatcher";
import { LegacyAppRedirect } from "@common/pages/LegacyAppRedirect";
import { CallbackPage } from "@common/pages/login/CallbackPage";
import { LoginPage } from "@common/pages/login/LoginPage";

// Shell lazy: un utente tenant non scarica il codice console e viceversa.
const TenantApp = lazy(() => import("./app/TenantApp").then((m) => ({ default: m.TenantApp })));
const ConsoleApp = lazy(() => import("./console/ConsoleApp").then((m) => ({ default: m.ConsoleApp })));

const LEGACY_APP_PATHS: string[] = [
  "/dashboard", "/profile", "/sub-tenant", "/notfound",
  "/admin/*", "/catalog/*", "/territory/*", "/fieldops/*", "/reporting/*",
];

function App() {
  return (
    <BrowserRouter basename={Configuration.VITE_CONFIG_BASE_URL}>
      <Routes>
        <Route element={<PublicLayout />}>
          <Route path="/" element={<AuthGuard><HomeDispatcher /></AuthGuard>} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/callback" element={<CallbackPage />} />
          <Route path="/forbidden" element={<AuthGuard><ForbiddenPage /></AuthGuard>} />
          {LEGACY_APP_PATHS.map((path) => (
            <Route key={path} path={path} element={<LegacyAppRedirect />} />
          ))}
          <Route path="*" element={<AuthGuard><NotFoundPage /></AuthGuard>} />
        </Route>
        <Route path="/app/*" element={<Suspense fallback={<ShellFallback />}><TenantApp /></Suspense>} />
        <Route path="/console/*" element={<Suspense fallback={<ShellFallback />}><ConsoleApp /></Suspense>} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
